(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('FinancialByCustomerController', FinancialByCustomerController);

    FinancialByCustomerController.$inject = ['$scope', 'ExportService', '$uibModalInstance', 'Principal', '$state', 'ReportService', 'OrderBagServiceItemCustom', '$translate', 'CustomerCustom'];

    function FinancialByCustomerController($scope, ExportService, $uibModalInstance, Principal, $state, ReportService, OrderBagServiceItemCustom, translate, CustomerCustom) {
        var vm = this;
        vm.fromDateFilter = new Date();
        vm.toDateFilter = new Date();
        vm.selectedCustomer = null;

        vm.cancel = cancel;
        vm.confirm = confirm;
        vm.errorOnCreatingReport = false;
        vm.reportCreatedAndDownload = false;
        vm.errorOnCreatingReport = false;

        vm.searchCustomer = function (query) {

            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        vm.selectedCustomerChanged = function (selectedItem) {

            //if(selectedItem) {
            //
            //    var c = Customer.get({id:selectedItem.id});
            //    if (c != null) {
            //        vm.selectedCustomer = c;
            //    }
            //}
        }

        loadAll()

        function loadAll() {

        }

        function confirm() {


            vm.errorOnCreatingReport = true;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = false;

            var customerId = 0;
            if (vm.selectedCustomer != null) {
                customerId = vm.selectedCustomer.id;
            }

            var file = ExportService.export_excel_financial_by_customer(customerId, vm.fromDateFilter, vm.toDateFilter);
            ExportService.download_excel_file(file, onExportSuccess, onExportErrorr);


        }

        function onExportErrorr(error) {
            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = false;
            vm.errorOnCreatingReport = true;
        }

        function onExportSuccess(result) {

            vm.errorOnCreatingReport = false;
            vm.reportCreatedAndDownload = true;
            vm.errorOnCreatingReport = false;
            vm.downloadlink = result.dllink;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
